import { render } from "./UnlockSocialMediaPotential.vue?vue&type=template&id=14857c16&scoped=true"
import script from "./UnlockSocialMediaPotential.vue?vue&type=script&lang=js"
export * from "./UnlockSocialMediaPotential.vue?vue&type=script&lang=js"

import "./UnlockSocialMediaPotential.vue?vue&type=style&index=0&id=14857c16&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14857c16"]])

export default __exports__